var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Assets",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Outline Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.405,6.2H22.248v-2.1a2.07,2.07,0,0,0-2.067-2.067H11.929A2.07,2.07,0,0,0,9.862,4.094V6.2H3.6V8.266H5.708V26.613a3.21,3.21,0,0,0,3.027,3.36h14.62a3.21,3.21,0,0,0,3.027-3.36V8.266h2.023Zm-16.476-2.1h8.252V6.2H11.929ZM24.315,26.613c0,.7-.44,1.293-.96,1.293H8.735c-.52,0-.96-.592-.96-1.293V8.266h16.54ZM13.738,13.437V23.77a.775.775,0,1,1-1.55,0V13.437a.775.775,0,1,1,1.55,0Zm6.2,0V23.77a.776.776,0,0,1-1.551,0V13.437a.776.776,0,0,1,1.551,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.8a8984520a87f3ca8f92a57cb6dd869c.svg";
export { ForwardRef as ReactComponent };